import { IonIcon, IonItem, IonLabel, IonList } from '@ionic/react';
import { useStyletron } from 'baseui';
import { Avatar } from 'baseui/avatar';
import { Block } from 'baseui/block';
import { HeadingLarge, LabelXSmall, ParagraphLarge, ParagraphMedium, ParagraphSmall } from 'baseui/typography';
import { chatbubble, helpCircle, informationCircle, lockClosedSharp, refreshSharp, settingsSharp, wallet, globe, eye } from 'ionicons/icons';
import { useState } from 'react';
import { MdCookie } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAccount, signOut } from '../application/actions/auth';
import { routeTo, setPortalElement } from '../application/actions/ui';
import { getWallet } from '../application/selectors/wallet';
import useCognito from '../hooks/useCognito';
import useWhoAmI from '../hooks/useWhoAmI';
import useLocale from '../hooks/useLocale';
import ReDoBackButton from './ReDoBackButton';
import ReDoButton from './ReDoButton';
import ReDoPublicSolutionsSettings from './ReDoPublicSolutionsSettings';



const ReDoSettings = ({ defaultItem }) => {
  const dispatch = useDispatch();
  const [css, theme] = useStyletron();
  const [walletVisible, setWalletVisible] = useState(defaultItem || false)
  const [profileSettingsVisible, setProfileSettingsVisible] = useState(false)
  const [languageVisible, setLanguageVisible] = useState(false)
  const [publicSolutionsVisible, setPublicSolutionsVisible] = useState(false)

  const walletData = useSelector(getWallet)
  const { t, language, changeLanguage } = useLocale();

  const { isCompany, userProfile, isFederated } = useWhoAmI();
  const { user } = useCognito()

  const onWalletClick = () => {
    setWalletVisible(true)
  }

  const onProfileClick = () => {
    !isCompany && dispatch(setPortalElement({ element: 'profileContainer', payload: { user: userProfile } }))
  }

  const onProfileSettingsClick = () => {
    setProfileSettingsVisible(true)
  }

  const onForgotPassword = () => {
    dispatch(routeTo({ view: 'forgotPassword', payload: { settings: true } }))
  }

  const onLanguageClick = () => {
    setLanguageVisible(true)
  }

  const onPublicSolutionsClick = () => {
    setPublicSolutionsVisible(true)
  }

  return (
    <>
      {!walletVisible && !profileSettingsVisible && !languageVisible && !publicSolutionsVisible ? (
        <>
          <IonList inset className={css({ margin: '1ch 0 !important' })}>

            <IonItem onClick={onProfileClick} lines='none' button={!isCompany} className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
              <Block alignItems='center' display='flex' margin='1ch 0' gridGap='2ch'>
                <Avatar name={userProfile.fullname} size="64px" src={userProfile.photo} />
                <Block display='flex' flexDirection='column'>
                  <ParagraphMedium marginTop='0' marginBottom='0' overrides={{ Block: { style: { fontWeight: 'bold' } } }}>
                    {userProfile.fullname}
                  </ParagraphMedium>
                  <ParagraphMedium overrides={{ Block: { style: { fontWeight: '500' } } }} color={theme.colors.primary400} marginTop='0' marginBottom='0'>{t('settings.nav_my_profile')}</ParagraphMedium>
                </Block>
              </Block>
            </IonItem>

            <Block backgroundColor='white' display='flex' justifyContent='center'>
              <Block height='1px' backgroundColor={theme.colors.secondary200} width='96%' />
            </Block>

            <IonItem lines='none' onClick={onProfileSettingsClick} button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
              <IonIcon className={css({ color: theme.colors.secondary200 })} icon={settingsSharp} slot="start"></IonIcon>
              <IonLabel className={css({ fontWeight: '500' })}>{t('settings.nav_profile_settings')}</IonLabel>
            </IonItem>

          </IonList>

          <IonList inset className={css({ margin: '1ch 0 !important' })}>

            <IonItem onClick={onWalletClick} lines='none' button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
              <IonIcon className={css({ color: theme.colors.secondary200 })} icon={wallet} slot="start"></IonIcon>
              <IonLabel className={css({ fontWeight: '500' })}>{t('settings.nav_wallet')}</IonLabel>
            </IonItem>

          </IonList>

          {!isCompany &&
            <IonList inset className={css({ margin: '1ch 0 !important' })}>
              <IonItem onClick={onPublicSolutionsClick} lines='none' button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
                <IonIcon className={css({ color: theme.colors.secondary200 })} icon={eye} slot="start"></IonIcon>
                <IonLabel className={css({ fontWeight: '500' })}>{t('settings.nav_public_solutions')}</IonLabel>
              </IonItem>
            </IonList>
          }

          <IonList inset className={css({ margin: '1ch 0 !important' })}>

            <IonItem href='https://landing.redo-please.com' target='_blank' lines='none' button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
              <IonIcon className={css({ color: theme.colors.secondary200 })} icon={informationCircle} slot="start"></IonIcon>
              <IonLabel className={css({ fontWeight: '500' })}>{t('settings.nav_about')}</IonLabel>
            </IonItem>
            <Block backgroundColor='white' display='flex' justifyContent='center'>
              <Block height='1px' backgroundColor={theme.colors.secondary200} width='96%' />
            </Block>
            <IonItem href='https://landing.redo-please.com/sustainability' target='_blank' lines='none' button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
              <IonIcon className={css({ color: theme.colors.secondary200 })} icon={refreshSharp} slot="start"></IonIcon>
              <IonLabel className={css({ fontWeight: '500' })}>{t('settings.nav_sustainability')}</IonLabel>
            </IonItem>

          </IonList>

          <IonList inset className={css({ margin: '1ch 0 !important' })}>

            <IonItem href='https://landing.redo-please.com/cookies' target='_blank' lines='none' button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
              <MdCookie color={theme.colors.secondary200} size='1.6em' slot='start' />
              <IonLabel className={css({ fontWeight: '500' })}>{t('settings.nav_cookies')}</IonLabel>
            </IonItem>
            <Block backgroundColor='white' display='flex' justifyContent='center'>
              <Block height='1px' backgroundColor={theme.colors.secondary200} width='96%' />
            </Block>
            <IonItem href='https://landing.redo-please.com/agb' target='_blank' lines='none' button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
              <IonIcon className={css({ color: theme.colors.secondary200 })} icon={lockClosedSharp} slot="start"></IonIcon>
              <IonLabel className={css({ fontWeight: '500' })}>{t('settings.nav_terms')}</IonLabel>
            </IonItem>
            <Block backgroundColor='white' display='flex' justifyContent='center'>
              <Block height='1px' backgroundColor={theme.colors.secondary200} width='96%' />
            </Block>
            <IonItem href='https://landing.redo-please.com/help' target='_blank' lines='none' button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
              <IonIcon className={css({ color: theme.colors.secondary200 })} icon={helpCircle} slot="start"></IonIcon>
              <IonLabel className={css({ fontWeight: '500' })}>{t('settings.nav_help')}</IonLabel>
            </IonItem>
            <Block backgroundColor='white' display='flex' justifyContent='center'>
              <Block height='1px' backgroundColor={theme.colors.secondary200} width='96%' />
            </Block>
            <IonItem href='https://landing.redo-please.com/feedback' target='_blank' lines='none' button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
              <IonIcon className={css({ color: theme.colors.secondary200 })} icon={chatbubble} slot="start"></IonIcon>
              <IonLabel className={css({ fontWeight: '500' })}>{t('settings.nav_feedback')}</IonLabel>
            </IonItem>

          </IonList>

          <IonList inset className={css({ margin: '1ch 0 !important' })}>

            <IonItem onClick={onLanguageClick} lines='none' button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
              <IonIcon className={css({ color: theme.colors.secondary200 })} icon={globe} slot="start"></IonIcon>
              <IonLabel className={css({ fontWeight: '500' })}>{t('settings.nav_language')}</IonLabel>
            </IonItem>

          </IonList>

          <Block display='flex' justifyContent='center' marginTop='3ch'>
            <ReDoButton kind='link' onClick={() => dispatch(signOut)}>{t('settings.btn_sign_out')}</ReDoButton>
          </Block>
        </>
      ) : (

        <>
          {walletVisible &&
            <>
              <ReDoBackButton onClick={() => setWalletVisible()} />
              {isCompany ?
                <>
                  <Block marginBottom='4ch'>
                    <ParagraphLarge>{t('settings.wallet_subscription_heading')}</ParagraphLarge>
                    <IonList inset className={css({ margin: '1ch 0 !important' })}>
                      <IonItem lines='none' className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
                        <Block margin='1ch 0' paddingRight='1ch' width='100%' display='flex' justifyContent='space-between'>
                          <Block width='75%'>
                            <ParagraphMedium overrides={{ Block: { style: { fontWeight: 'bold' } } }}>{walletData.subscription?.subscriptionName} ({walletData.subscription?.price}/month)</ParagraphMedium>
                            <ParagraphSmall color={theme.colors.primary400} marginBottom='0'>{t('settings.wallet_coins_balance', { balance: walletData.balance })}</ParagraphSmall>
                            <ParagraphSmall color={theme.colors.primary400} marginTop='0'>{t('settings.wallet_next_coins', { date: new Date(walletData.subscription?.nextPayment).toLocaleDateString() })}</ParagraphSmall>
                          </Block>

                          <Block paddingLeft='2ch' overrides={{ Block: { style: { borderLeft: `1px solid ${theme.colors.secondary0}` } } }} width='25%'>
                            <ParagraphMedium overrides={{ Block: { style: { fontWeight: 'bold' } } }}>{t('settings.wallet_you_get')}</ParagraphMedium>
                            <ParagraphSmall color={theme.colors.primary400} marginBottom='0'>{t('settings.wallet_per_month', { amount: walletData.subscription?.amountOfCoins })}</ParagraphSmall>
                            <ParagraphSmall color={theme.colors.primary400} marginTop='0'>{t('settings.wallet_challenges', { count: walletData.subscription?.amountOfChallenges })}</ParagraphSmall>
                          </Block>
                        </Block>
                      </IonItem>
                    </IonList>
                  </Block>

                  <IonList inset className={css({ margin: '1ch 0 !important' })}>
                    <IonItem lines='none' button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
                      <a className={css({ fontWeight: '500', textDecoration: 'none' })} target='_blank' rel='noreferrer' href="https://billing.stripe.com/p/login/test_5kA7thai2a0W1Bm9AA">{t('settings.wallet_manage_link')}</a>
                    </IonItem>
                  </IonList>
                </>
                :
                <IonList inset className={css({ margin: '1ch 0 !important' })}>
                  <IonItem lines='none' className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
                    <ParagraphSmall>{t('settings.wallet_user_coins', { balance: walletData.balance })}</ParagraphSmall>
                  </IonItem>
                </IonList>

              }
            </>
          }
          {profileSettingsVisible &&
            <>
              <ReDoBackButton onClick={() => setProfileSettingsVisible()} />
              <Block display='flex' flexDirection='column'>
                <Block alignSelf='center'>
                  <Avatar
                    name={userProfile.fullname}
                    size="96px"
                    src={userProfile.photo}
                  />
                </Block>
                <Block alignSelf='center' display='flex' flexDirection='column' alignItems='center'>
                  <HeadingLarge marginBottom='0' overrides={{ Block: { style: { fontWeight: 'bold' } } }}>{userProfile.fullname}</HeadingLarge>
                  <ParagraphMedium marginTop='0'>{userProfile.username ? `@${userProfile.username}` : userProfile.name}</ParagraphMedium>
                </Block>

                <Block marginTop='3ch' alignSelf='end' display='flex' alignItems='end' paddingRight='1ch' paddingBottom='1ch'>
                  <ReDoButton onClick={() => dispatch(routeTo({ view: isCompany ? 'companyCreateProfile' : 'userCreateProfile' }))} overrides={{ BaseButton: { style: { boxShadow: 'none' } } }} kind='link'><LabelXSmall color='#0000ffa3'>{t('settings.profile_label_edit')}</LabelXSmall></ReDoButton>
                </Block>

                <IonList inset className={css({ margin: '1ch 0 !important' })}>
                  <IonItem lines='none' className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
                    <Block alignItems='center' paddingRight='2ch' width='100%' display='flex' justifyContent='space-between'>
                      <LabelXSmall>{t('settings.profile_field_name')}</LabelXSmall>
                      <ParagraphSmall>{userProfile.fullname}</ParagraphSmall>
                    </Block>
                  </IonItem>
                  <Block backgroundColor='white' display='flex' justifyContent='center'>
                    <Block height='1px' backgroundColor={theme.colors.secondary200} width='96%' />
                  </Block>
                  <IonItem lines='none' className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
                    <Block alignItems='center' paddingRight='2ch' width='100%' display='flex' justifyContent='space-between'>
                      <LabelXSmall>{t('settings.profile_field_pronouns')}</LabelXSmall>
                      <ParagraphSmall>{userProfile.pronouns}</ParagraphSmall>
                    </Block>
                  </IonItem>
                  <Block backgroundColor='white' display='flex' justifyContent='center'>
                    <Block height='1px' backgroundColor={theme.colors.secondary200} width='96%' />
                  </Block>
                  <IonItem lines='none' className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
                    <Block alignItems='center' paddingRight='2ch' width='100%' display='flex' justifyContent='space-between'>
                      <LabelXSmall>{t('settings.profile_field_mail')}</LabelXSmall>
                      <ParagraphSmall>{user.attributes.email}</ParagraphSmall>
                    </Block>
                  </IonItem>
                  <Block backgroundColor='white' display='flex' justifyContent='center'>
                    <Block height='1px' backgroundColor={theme.colors.secondary200} width='96%' />
                  </Block>
                  <IonItem lines='none' className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
                    <Block alignItems='center' paddingRight='2ch' width='100%' display='flex' justifyContent='space-between'>
                      <LabelXSmall>{t('settings.profile_field_location')}</LabelXSmall>
                      <ParagraphSmall>{userProfile.city}, {userProfile.country}</ParagraphSmall>
                    </Block>
                  </IonItem>
                </IonList>

                {!isFederated && (
                  <IonList onClick={onForgotPassword} inset className={css({ margin: '1ch 0 !important' })}>
                    <IonItem lines='none' button className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' }, '::part(detail-icon)': { color: 'black' } })}>
                      <LabelXSmall>{t('settings.profile_change_password')}</LabelXSmall>
                    </IonItem>
                  </IonList>
                )}

                <Block display='flex' justifyContent='center' marginTop='6ch'>
                  <ReDoButton overrides={{ BaseButton: { style: { boxShadow: 'none' } } }} kind='link' onClick={() => {
                    if (window.confirm(t('settings.delete_account_confirm'))) {
                      dispatch(deleteAccount(isCompany))
                    }
                  }}><ParagraphMedium color='red'>{t('settings.delete_account_btn')}</ParagraphMedium></ReDoButton>
                </Block>

              </Block>
            </>
          }

          {publicSolutionsVisible &&
            <ReDoPublicSolutionsSettings userId={userProfile.userId} onBack={() => setPublicSolutionsVisible(false)} />
          }

          {languageVisible &&
            <>
              <ReDoBackButton onClick={() => setLanguageVisible(false)} />
              <Block marginBottom='4ch'>
                <ParagraphLarge>{t('settings.nav_language')}</ParagraphLarge>
                <IonList inset className={css({ margin: '1ch 0 !important' })}>
                  <IonItem lines='none' className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' } })}>
                    <Block width='100%' display='flex' alignItems='center' gridGap='1ch'>
                      <input
                        type='radio'
                        name='language'
                        value='en'
                        checked={language === 'en'}
                        onChange={() => changeLanguage('en')}
                        style={{ cursor: 'pointer' }}
                      />
                      <IonLabel className={css({ fontWeight: '500', cursor: 'pointer' })} onClick={() => changeLanguage('en')}>
                        {t('settings.language_english')}
                      </IonLabel>
                    </Block>
                  </IonItem>
                  <Block backgroundColor='white' display='flex' justifyContent='center'>
                    <Block height='1px' backgroundColor={theme.colors.secondary200} width='96%' />
                  </Block>
                  <IonItem lines='none' className={css({ '::part(native)': { background: 'white', paddingTop: '.5ch', paddingBottom: '.5ch' } })}>
                    <Block width='100%' display='flex' alignItems='center' gridGap='1ch'>
                      <input
                        type='radio'
                        name='language'
                        value='de'
                        checked={language === 'de'}
                        onChange={() => changeLanguage('de')}
                        style={{ cursor: 'pointer' }}
                      />
                      <IonLabel className={css({ fontWeight: '500', cursor: 'pointer' })} onClick={() => changeLanguage('de')}>
                        {t('settings.language_german')}
                      </IonLabel>
                    </Block>
                  </IonItem>
                </IonList>
              </Block>
            </>
          }
        </>
      )}

    </>
  );
};

export default ReDoSettings;